import type { NextPageWithLayout } from 'next';
import { useEffect } from 'react';

import { BackedByExperts } from '@/components/homepage';
import ShopLayout from '@/components/layouts/ShopLayout';
import PricingHeaderSection from '@/components/pricing/PricingHeaderSection';
import PricingStep1Section from '@/components/pricing/PricingStep1Section';
import PricingStep2Section from '@/components/pricing/PricingStep2Section';
import PricingTrueMedSection from '@/components/pricing/PricingTrueMedSection';
import FAQSection from '@/components/sections/FAQSection';
import StartJourneyCTA from '@/components/sections/StartJourneyCTA';
import { YotpoReviews } from '@/components/sections/YotpoReviews';
import KnowMoreSection from '@/components/shop/KnowMoreSection';
import { getGallery, getPricingPageFAQ } from '@/graphql/contentful';
import { addApolloState, initializeApollo } from '@/lib/apollo/apollo-client';
import { appsFlyerEvent } from '@/lib/apps-flyer/apps-flyer';
import type { GalleryT } from '@/utils/contentfulTypes';

export async function getStaticProps() {
  const apolloClient = initializeApollo();
  const faq = await getPricingPageFAQ();
  const backedByExpertsFrom: GalleryT = (await getGallery('WCXyxSxENS9UNgD9P9ITO')) as GalleryT;

  return addApolloState(apolloClient, {
    props: {
      faq,
      backedByExpertsFrom,
    },
    revalidate: 60, // 1 minute
  });
}

export type PricingPageProps = {
  faq: any;
  backedByExpertsFrom: GalleryT;
};

const PricingPage: NextPageWithLayout<PricingPageProps> = ({ faq, backedByExpertsFrom }) => {
  useEffect(() => {
    appsFlyerEvent('PRICING LOAD', {});
  }, []);

  return (
    <>
      <PricingHeaderSection />
      <PricingStep1Section />
      <PricingStep2Section />
      <BackedByExperts
        headline={backedByExpertsFrom.headline}
        items={backedByExpertsFrom.imagesCollection.items}
        className="bg-white py-8 md:block"
      />
      <PricingTrueMedSection />
      <FAQSection
        preHeader="FAQS"
        items={faq}
        title="Frequently asked questions"
        titleClassName="md:text-[40px] font-light"
      />
      <YotpoReviews />
      <KnowMoreSection />
      <StartJourneyCTA variant="dna" ctaText="Get your DNA Fitness & Health Report first" />
    </>
  );
};

export default PricingPage;

PricingPage.getLayout = (page) => {
  return (
    <ShopLayout dark>
      <div className="w-full bg-white">{page}</div>
    </ShopLayout>
  );
};
